import "trix";

const { blockAttributes: defaultBlockAttributes } = Trix.config;

export default {
  blockAttributes: {
    heading1: {
      ...defaultBlockAttributes.heading1,
      tagName: "h2",
      terminal: false,
      group: false,
    },
    alignLeft: {
      tagName: "align-left",
    },
    alignCenter: {
      tagName: "align-center",
    },
    alignRight: {
      tagName: "align-right",
    },
  },
  toolbar: {
    getDefaultHTML: () => {
      return `<div class="trix-button-row">
        <span class="trix-button-group trix-button-group--text-tools">
          <button
            type="button"
            class="trix-button trix-button--icon trix-button--icon-bold"
            data-trix-attribute="bold"
            title="太字"
            tabindex="-1"
          >
            太字
          </button>
          <button
            type="button"
            class="trix-button trix-button--icon trix-button--icon-italic"
            data-trix-attribute="italic"
            title="斜体"
            tabindex="-1"
          >
            斜体
          </button>
          <button
            type="button"
            class="trix-button trix-button--icon trix-button--icon-heading"
            data-trix-attribute="heading1"
            title="見出し"
            tabindex="-1"
          >
            見出し
          </button>
          <button
            type="button"
            class="trix-button trix-button--icon trix-button--icon-align-left"
            data-trix-attribute="alignLeft"
            title="左揃え"
            tabindex="-1"
          >
            左揃え
          </button>
          <button
            type="button"
            class="trix-button trix-button--icon trix-button--icon-align-center"
            data-trix-attribute="alignCenter"
            title="中央揃え"
            tabindex="-1"
          >
            中央揃え
          </button>
          <button
            type="button"
            class="trix-button trix-button--icon trix-button--icon-align-right"
            data-trix-attribute="alignRight"
            title="右揃え"
            tabindex="-1"
          >
            右揃え
          </button>
        </span>
      </div>`;
    },
  },
};
